import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef } from 'react';
import { Anchor } from '@mirohq-internal/website-ui-foundation';
import { OffCanvasLanguageList } from './off-canvas-language-list/off-canvas-language-list.esm.js';
import { OverlayLanguageList } from './overlay-language-list/overlay-language-list.esm.js';

const LanguageSelector = ({ onChangeLocale, selectedValue, title, items })=>{
    const [show, setShow] = useState(false);
    const target = useRef(null);
    const handleClose = ()=>setShow(false);
    const handleSelect = (value)=>{
        const locale = items.find((item)=>item.label === value)?.locale || '';
        onChangeLocale?.(locale);
    };
    if (items.length <= 1) {
        /**
         * If there is only one language, we don't need to show the language selector.
         */ return null;
    }
    return jsxs("div", {
        className: "d-flex justify-content-around align-items-center gap-100",
        children: [
            jsx(Anchor, {
                ref: target,
                iconEnd: "Globe",
                onClick: ()=>setShow(!show),
                children: selectedValue
            }),
            jsx(OffCanvasLanguageList, {
                className: "d-flex d-md-none",
                selectedValue: selectedValue,
                show: show,
                handleSelect: handleSelect,
                handleClose: handleClose,
                title: title,
                items: items
            }),
            jsx(OverlayLanguageList, {
                handleClose: handleClose,
                selectedValue: selectedValue,
                show: show,
                handleSelect: handleSelect,
                title: title,
                items: items,
                target: target
            })
        ]
    });
};

export { LanguageSelector };
